/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Amount_FertilizingInputs */

const vi_care_log_amount_fertilizing = /** @type {(inputs: Care_Log_Amount_FertilizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng đã bón`)
};

/**

* @param {Care_Log_Amount_FertilizingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_amount_fertilizing = /** @type {((inputs?: Care_Log_Amount_FertilizingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Amount_FertilizingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_amount_fertilizing(inputs)
});